var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#604CC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.25c0 2.9-2.687 5.25-6 5.25a6.797 6.797 0 0 1-1.76-.23c-.438.223-1.444.649-3.136.926-.15.024-.264-.132-.205-.272a7.995 7.995 0 0 0 .578-2.224C5.558 12.778 5 11.57 5 10.25 5 7.35 7.686 5 11 5c3.313 0 6 2.35 6 5.25ZM8.375 8a.375.375 0 1 0 0 .75h5.25a.375.375 0 0 0 0-.75h-5.25Zm0 1.875a.375.375 0 1 0 0 .75h5.25a.375.375 0 0 0 0-.75h-5.25Zm0 1.875a.375.375 0 1 0 0 .75h3a.375.375 0 0 0 0-.75h-3Z",
    fill: "#FDFDFE"
  })));
};

export default SvgChat;